import { useDispatch } from "react-redux";

import { MeasuringSystem } from "../../store/Session/SessionModel";
import sessionSlice from "../../store/Session/SessionSlice";

import "./style.css";
import TypedSegmented from "rc-segmented";

interface Props {
  measuringSystem: MeasuringSystem;
}

const Imperial = ({ measuringSystem }: Props): JSX.Element => {
  const dispatch = useDispatch();

  const setMeasuringSystem = (measuringSystem: MeasuringSystem) => {
    dispatch(
      sessionSlice.actions.setMeasuringSystem({
        measuringSystem: measuringSystem
      })
    );
  };
  return (
    <div className="wrapper-segment">
      <TypedSegmented
        options={[MeasuringSystem.imperial, MeasuringSystem.metric]}
        value={measuringSystem}
        onChange={(value) => setMeasuringSystem(value)}
      />
    </div>
  );
};

export default Imperial;
